import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

// Externals
import PropTypes from "prop-types";
import compose from "recompose/compose";
import validate from "validate.js";
import _ from "lodash";

// Material helpers
import { withStyles } from "@material-ui/core";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  login as loginAction,
  confirmLogin as confirmLoginAction,
  confirmRegistration,
  resendConfirmationCode,
  isLoading as loading,
  setNewPassword,
  resendConfirmationCode as resendCodeAction
} from "../../redux/actions/authActions";

import { AUTH_ERROR_CLEAR } from "../../redux/actions/types";
import { store } from "../../index";

// Material components
import { Grid, Button, IconButton, CircularProgress, TextField, Typography } from "@material-ui/core";

// Material icons
// import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";

// Shared components
// import { Facebook as FacebookIcon, Google as GoogleIcon } from "icons";

// Component styles
import styles from "./styles";

// Form validation schema
import { loginForm, changePasswordForm } from "./schema";
import PopUpMessages from "../../components/PopUpMessages/PopUpMessages";
import { removeMessage } from "../../redux/actions/commonActions";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

class SignIn extends Component {
  state = {
    values: {
      email: "",
      password: "",
      newPassword: "",
      newPasswordConfirm: "",
      code: ""
    },
    touched: {
      email: false,
      password: false,
      newPassword: false,
      newPasswordConfirm: false,
      code: false
    },
    errors: {
      email: null,
      password: null,
      newPassword: null,
      newPasswordConfirm: null,
      code: null
    },
    isValid: false,
    schema: undefined,
    submitError: null,
    dissableSignUp: config.SIGNUP_DISSABLED === true
  };

  componentDidMount() {
    store.dispatch(function(dispatch) {
      // ... which themselves may dispatch many times
      dispatch({ type: AUTH_ERROR_CLEAR });
    });
  }

  handleBack = () => {
    const { history } = this.props;

    history.goBack();
  };

  validateForm = _.debounce(() => {
    const { values, touched } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, touched.newPassword ? changePasswordForm : loginForm);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };

    newState.submitError = null;
    newState.touched[field] = true;
    newState.values[field] = value;

    this.setState(newState, this.validateForm);
  };

  handleResendVerificationCode = () => {
    const email = { cognitoUser: { user: { username: this.state.values.email } } };
    this.props.resendCodeAction(email, this.props.history);
  };

  handleSignIn = e => {
    e.preventDefault();
    this.props.loading(true);

    // dispatch clear error message before unmount, sign-in sign-up screen switch
    store.dispatch(function(dispatch) {
      // ... which themselves may dispatch many times
      dispatch({ type: AUTH_ERROR_CLEAR });
    });

    // console.log("this.props.location", this.props.location);

    try {
      const { mfaRequired, cognitoUser, loginRegisterConfirm } = this.props;
      const { values } = this.state;
      const code = this.state.values.code;

      const { email, password } = values;

      // this.setState({ isLoading: true });

      // await signIn(values.email, values.password);
      if (loginRegisterConfirm === true) {
        console.log("loginRegisterConfirm === true");
        this.props.confirmRegistration(
          { cognitoUser: { user: values.email }, code, email, password },
          this.props.history
        );
      } else if (typeof mfaRequired === "undefined" || mfaRequired === false) {
        // localStorage.setItem("isAuthenticated", true);
        this.props.loginAction(values.email, values.password, this.props.history, this.props.location);
      } else if (
        mfaRequired === true
        // && changePassword == false
      ) {
        // we pass in the history function so we can navigate from loginAction
        this.props.confirmLoginAction({ cognitoUser, code }, this.props.history, this.props.location);
      }
      // history.push("/dashboard");
    } catch (error) {
      this.setState({
        // isLoading: false,
        serviceError: error
      });
    }
  };

  handleChangePassword = e => {
    e.preventDefault();

    this.props.setNewPassword(this.props.cognitoUser, this.state.values.newPassword, this.props.history);
  };

  render() {
    const {
      classes,
      mfaRequired,
      resendCode,
      isLoading,
      errorMessage,
      loginRegisterConfirm,
      cognitoUser,
      changePassword,
      message,
      removeMessage
    } = this.props;
    const { values, touched, errors, isValid } = this.state;

    const showEmailError = touched.email && errors.email;
    const showPasswordError = touched.password && errors.password;

    const showNewPasswordError =
      touched.newPasswordConfirm && errors.newPasswordConfirm ? errors.newPasswordConfirm[0] : false;

    return (
      <div className={classes.root}>
        <Grid className={classes.grid} container>
          <Grid className={classes.quoteWrapper} item lg={5}>
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography className={classes.quoteText} variant="h2">
                  Automatic Speech Recognition. Natural Language Understanding.
                </Typography>
                <Typography className={classes.quoteText} variant="h1">
                  <b>Built for Enterprises.</b>
                </Typography>
                <div className={classes.person}>
                  <Typography className={classes.name} variant="body1">
                    Powered by Responsum.
                  </Typography>
                  <Typography className={classes.bio} variant="body1">
                    Commanded by you.
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid className={classes.content} item lg={7} xs={12}>
            <div className={classes.content}>
              <div className={classes.contentHeader}>
                <IconButton className={classes.backButton} onClick={this.handleBack}>
                  {/* <ArrowBackIcon /> */}
                </IconButton>
              </div>

              <div className={classes.contentBody}>
                {!mfaRequired && !loginRegisterConfirm && !changePassword && (
                  <form className={classes.form} onSubmit={this.handleSignIn}>
                    <Typography className={classes.title} variant="h4">
                      Sign in with your email address
                    </Typography>

                    <div className={classes.fields}>
                      <TextField
                        autoFocus
                        className={classes.textField}
                        label="Email address"
                        name="email"
                        onChange={event => this.handleFieldChange("email", event.target.value)}
                        type="text"
                        value={values.email}
                        variant="outlined"
                      />
                      {showEmailError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.email[0]}
                        </Typography>
                      )}
                      <TextField
                        className={classes.textField}
                        label="Password"
                        name="password"
                        onChange={event => this.handleFieldChange("password", event.target.value)}
                        type="password"
                        value={values.password}
                        variant="outlined"
                      />
                      {showPasswordError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.password[0]}
                        </Typography>
                      )}
                    </div>
                    {errorMessage && (
                      <Typography className={classes.submitError} variant="body2">
                        {errorMessage}
                      </Typography>
                    )}
                    {isLoading ? (
                      <CircularProgress className={classes.progress} />
                    ) : (
                      <Button
                        className={classes.signInButton}
                        color="primary"
                        disabled={!isValid}
                        // onClick={this.handleSignIn}
                        size="large"
                        variant="contained"
                        type="submit"
                      >
                        Sign in now
                      </Button>
                    )}
                    {this.state.dissableSignUp ? (
                      ""
                    ) : (
                      <Typography className={classes.signUp} variant="h6">
                        Don't have an account?{" "}
                        <Link className={classes.signUpUrl} to="/sign-up">
                          Sign up
                        </Link>
                      </Typography>
                    )}
                    <Typography className={classes.signUp} variant="h6">
                      Did you forget your password?{" "}
                      <Link className={classes.signUpUrl} to="/forgot-password">
                        Reset password
                      </Link>
                    </Typography>
                  </form>
                )}

                {mfaRequired && !loginRegisterConfirm && (
                  <form className={classes.form} onSubmit={this.handleSignIn}>
                    <Typography className={classes.title} variant="h2">
                      MFA
                    </Typography>
                    <Typography className={classes.subtitle} variant="body1">
                      {cognitoUser.challengeName === "SOFTWARE_TOKEN_MFA"
                        ? "Please enter MFA code from your software application"
                        : cognitoUser.challengeName === "SMS_MFA"
                        ? "MFA code has been sent on your SMS"
                        : "Please enter MFA code"}
                    </Typography>
                    <div className={classes.fields}>
                      <TextField
                        required
                        className={classes.textField}
                        label="Enter code"
                        name="code"
                        onChange={event => this.handleFieldChange("code", event.target.value)}
                        value={values.code}
                        variant="outlined"
                        autoComplete="off"
                      />
                      <Button
                        className={classes.signInButton}
                        color="primary"
                        disabled={!isValid}
                        // onClick={this.handleSignIn}
                        size="large"
                        variant="contained"
                        type="submit"
                      >
                        Verify
                      </Button>
                      {resendCode && cognitoUser.challengeName === "SMS_MFA" && (
                        <Button
                          className={classes.signInButton}
                          color="primary"
                          // onClick={this.handleSignIn}
                          size="large"
                          variant="contained"
                          type="submit"
                        >
                          Resend Code
                        </Button>
                      )}
                      {errorMessage && (
                        <Typography className={classes.submitError} variant="body2">
                          {errorMessage}
                        </Typography>
                      )}
                    </div>
                  </form>
                )}
                {loginRegisterConfirm && (
                  <form className={classes.form} onSubmit={this.handleSignIn}>
                    <Typography className={classes.title} variant="h2">
                      Verify your email
                    </Typography>
                    <Typography className={classes.subtitle} variant="body1">
                      Verification code has been sent on your email
                    </Typography>
                    <div className={classes.fields}>
                      <TextField
                        required
                        className={classes.textField}
                        label="Enter code"
                        name="code"
                        onChange={event => this.handleFieldChange("code", event.target.value)}
                        value={values.code}
                        variant="outlined"
                        autoComplete="off"
                      />

                      {errorMessage && (
                        <Typography className={classes.submitError} variant="body2">
                          {errorMessage}
                        </Typography>
                      )}

                      {isLoading ? (
                        <CircularProgress className={classes.progress} />
                      ) : (
                        <React.Fragment>
                          <Button
                            className={classes.signInButton}
                            color="primary"
                            disabled={!isValid}
                            // onClick={this.handleSignUp}
                            size="large"
                            variant="contained"
                            type="submit"
                          >
                            Verify
                          </Button>
                          <Typography className={classes.signUp} variant="h6">
                            Didn't get the code?{" "}
                            <Link className={classes.signUpUrl} onClick={this.handleResendVerificationCode}>
                              Resend
                            </Link>
                          </Typography>
                        </React.Fragment>
                      )}
                    </div>
                  </form>
                )}
                {this.props.changePassword && (
                  <form className={classes.form} onSubmit={this.handleChangePassword}>
                    <Typography className={classes.title} variant="h2">
                      Change your password
                    </Typography>
                    <Typography className={classes.subtitle} variant="body1">
                      User this form below to set a new password for your account
                    </Typography>
                    <div className={classes.fields}>
                      <TextField
                        required
                        autoFocus
                        className={classes.textField}
                        label="New Password"
                        name="newPassword"
                        onChange={event => this.handleFieldChange("newPassword", event.target.value)}
                        type="password"
                        value={values.newPassword}
                        variant="outlined"
                      />
                      <TextField
                        required
                        className={classes.textField}
                        label="Confirm New Password"
                        name="newPasswordConfirm"
                        onChange={event => this.handleFieldChange("newPasswordConfirm", event.target.value)}
                        type="password"
                        value={values.newPasswordConfirm}
                        variant="outlined"
                      />
                    </div>
                    {showNewPasswordError && (
                      <Typography className={classes.fieldError} variant="body2">
                        {errors.newPasswordConfirm[0]}
                      </Typography>
                    )}
                    <Button
                      className={classes.signInButton}
                      color="primary"
                      disabled={!isValid}
                      size="large"
                      variant="contained"
                      type="submit"
                    >
                      Reset Password
                    </Button>
                  </form>
                )}
              </div>
            </div>
            <PopUpMessages message={message} removeMessage={removeMessage} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

SignIn.propTypes = {
  loginAction: PropTypes.func,
  cognitoUser: PropTypes.object,
  errorMessage: PropTypes.string,
  changePassword: PropTypes.bool,
  handleSubmit: PropTypes.func,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  console.log("Login.mapStateToProps() state:", state);
  //console.log('Login.mapStateToProps() ownProps:', ownProps);
  return {
    errorMessage: state.auth.error,
    mfaRequired: state.auth.mfa,
    changePassword: state.auth.changePassword,
    cognitoUser: state.auth.cognitoUser,
    isLoading: state.auth.isLoading,
    loginRegisterConfirm: state.auth.login_register_confirm,
    message: state.common.message
  };
}

function mapDispatchToProps(dispatch) {
  //console.log('Login.mapDispatchToProps() ');
  // return {
  //   ...bindActionCreators(actionCreators, dispatch),
  //   dispatch
  // };

  return {
    ...bindActionCreators(
      {
        loginAction,
        confirmLoginAction,
        confirmRegistration,
        resendConfirmationCode,
        loading,
        setNewPassword,
        resendCodeAction,
        removeMessage
      },
      dispatch
    ),
    dispatch
  };
}

SignIn = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn);

export default compose(
  withRouter,
  withStyles(styles)
)(SignIn);
